import React, { Component } from "react";
import offresJson from '../../data/offre';
import { NavBarApp2 } from './NavBarApp2';
import ListUser from './Tab1/ListUser';
import { SearchInputOffers } from '../SearchInputOffers/SearchInputOffers';
import GroupedOffers from './Tab1/GroupedOffers';


export default class App2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
        filteredOffers: [],
        selectedOffre: {},
    };
    this.getOffer = this.getOffer.bind(this);
    this.searchOffers = this.searchOffers.bind(this);
  };

  componentDidMount = () => {
      this.setState({ selectedOffre: offresJson[0], filteredOffers: offresJson });
  };

  searchOffers = (val) => {
    this.setState({ filteredOffers: offresJson.filter(offer => offer.title.toUpperCase().includes(val.toUpperCase())) });
  };

  getOffer = (offer) => {
    this.setState({ selectedOffre: offresJson.filter(o => o.id === offer.id)[0] });
  };

  render() {

    const { selectedOffre, filteredOffers } = this.state;

    return (
      <div>
          <NavBarApp2/>

          <div style={{ margin: 10, paddingRight: 20, paddingLeft: 20 }} className="card">
                    <SearchInputOffers
                          onOfferInputChange={(val) => this.searchOffers(val)}
                    />
          </div>

          <div className="row">
            <div className="col s6">

              {
                  filteredOffers.map((offre, index) =>
                    <GroupedOffers key={index} offre={offre} setSelectedOffre={(offer) => this.getOffer(offer)} />
                  )
              }

            </div>
            <div className="col s6">
              <ListUser idOffre={selectedOffre.id}/>
            </div>
          </div>
      </div>
    );
  }
}